import React from "react";
import { ImmersiveAd } from "@bloomberg/media-ui-ads";
import { ImmersiveAdProps } from "@bloomberg/media-ui-ads/dist/ImmersiveAd";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./styles.module.css";

export default function StoryImmersiveAd({
    className,
    ...props
}: ImmersiveAdProps) {
    return (
        <ImmersiveAd
            className={createClasses([styles.storyImmersiveAd, className])}
            {...props}
        />
    );
}
